import { ref } from 'vue'

function resolveErpBaseUrl() {
  if (location.hostname === 'localhost') return 'http://localhost:8080'
  if (location.hostname.includes('staging'))
    return 'https://admin-staging.norm.eu'
  return 'https://admin.norm.eu'
}

export const erpBaseUrl = resolveErpBaseUrl()

// ERP links here carry ?use_erp_menu=true: show the ERP-style menu for the ERP screens
// hosted in this app (Projecten, PlanBaas, Gebruikers, ...). Read per page load, so it
// never outlives the visit.
export const useErpMenu = ref(
  new URLSearchParams(location.search).get('use_erp_menu') === 'true'
)
